import {mapMutations, mapGetters, mapActions} from "vuex";

import {TheMask} from 'vue-the-mask'
import {value} from "lodash/seq";

export default {
    name: "userInfo",
    components: {
        TheMask
    },
    data() {
        return {
            image: true,
            edit: false,
            editPassword: false,
            restorePassword: {
                password_current: '',
                password: '',
                password_confirmation: '',
            },
            error: {
                //empty passwords
                emptyOldPassword: false,
                emptyNewPassword: false,
                emptyConfirmPassword: false,

                //passwords length not match
                notMatchOldPassword: false,
                notMatchNewPassword: false,
                notMatchConfirmPassword: false,

                // various new & confirm passwords
                isVariousNewPassword: false,
                passwordIncorrect: false,
                passwordLength: false,

                passwordConsilience: false,
                emailInvalid: false
            },
            payload: {
                name: '',
                last_name: '',
                middle_name: '',
                email: '',
                phone: '',
                delivery_address: {
                    city: '',
                    street: '',
                    flat: ''
                },
                avatar: ''
            },
            preview: ''

        }
    },
    created() {
        this.userInfo().then(() => {
            this.getUserData()
        })
    },

    methods: {
        ...mapMutations({
            changeShowPopUpExit: 'auth/CHANGE_POPUP_USER_EXIT',
            changeShowPopUpPassword: 'auth/SHOW_CHANGE_PASSWORD_POPUP',
        }),
        ...mapActions({
            userInfo: 'userData/GET_DATA',
            fetchUpdateInfo: 'userData/UPDATE_DATA',
            updatePassword: 'auth/RESTORE_PASSWORD'
        }),

        setImage(file) {
            // let formData = new FormData()
            // formData.append('file', file.target.files[0])

            this.payload.avatar = file.target.files[0]
            this.preview = URL.createObjectURL(file.target.files[0])

        },

        resetAvatar() {
            this.preview = ''
            this.payload.avatar = ''
        },

        resetUserData() {
            this.getUserData()
            this.edit = false
        },

        cancelEditPassword() {
            this.editPassword = false

            for (let key in this.restorePassword) {
                this.restorePassword[key] = ''
            }
            for (let key in this.error) {
                this.error[key] = false
            }
        },

        submitNewPassword() {
//check matching passwords
            if (this.restorePassword.password_current.length !== 0
                && this.restorePassword.password.length !== 0
                && this.restorePassword.password_confirmation.length !== 0
                && this.restorePassword.password_current === this.restorePassword.password_confirmation
                && this.restorePassword.password_current === this.restorePassword.password) {
                this.error.passwordConsilience = true
            } else {
                this.error.passwordConsilience = false
            }

//check empty inputs
            if (this.restorePassword.password_current.length === 0) {
                this.error.emptyOldPassword = true
            } else {
                this.error.emptyOldPassword = false
            }
            if (this.restorePassword.password.length === 0) {
                this.error.emptyNewPassword = true
            } else {
                this.error.emptyNewPassword = false
            }
            if (this.restorePassword.password_confirmation.length === 0) {
                this.error.emptyConfirmPassword = true
            } else {
                this.error.emptyConfirmPassword = false
            }

//check passwords length

            if (this.restorePassword.password_current.length < 8 && this.restorePassword.password_current.length !== 0) {
                this.error.notMatchOldPassword = true
            } else {
                this.error.notMatchOldPassword = false
            }
            if (this.restorePassword.password.length < 8 && this.restorePassword.password.length !== 0) {
                this.error.notMatchNewPassword = true
            } else {
                this.error.notMatchNewPassword = false
            }
            if (this.restorePassword.password_confirmation.length < 8 && this.restorePassword.password_confirmation.length !== 0) {
                this.error.notMatchConfirmPassword = true
            } else {
                this.error.notMatchConfirmPassword = false
            }


            //check various new & confirm passwords
            if (this.restorePassword.password_confirmation !== this.restorePassword.password
                && this.restorePassword.password_confirmation.length >= 8
                && this.restorePassword.password.length >= 8
            ) {
                this.error.isVariousNewPassword = true
            } else {
                this.error.isVariousNewPassword = false
            }
            this.editPassword = true


            if (this.restorePassword.password_current.length >= 8) {
                this.updatePassword(this.restorePassword).then(() => {
                    this.editPassword = false
                    this.changeShowPopUpPassword(true)
                }).catch((error) => {
                    if (error) {
                        this.error.passwordIncorrect = true
                    }
                })
            }


        },
        sendNewData() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.payload.email)) {
                this.error.emailInvalid = true;
                return;
            }
            this.edit = !this.edit
            this.error.emailInvalid = false;
            let fd = new FormData()
            for (let dataKey in this.payload) {
                if (dataKey === 'delivery_address') {

                    for (let deliveryAddress in this.payload[dataKey]) {
                        fd.append(`delivery_address[${deliveryAddress}]`, this.payload[dataKey][deliveryAddress]);
                    }
                } else {
                    fd.append(dataKey, this.payload[dataKey]);
                }
            }

            this.fetchUpdateInfo(fd).then(() => {
                this.userInfo()
                this.edit = false;
            }).catch(error => {
                this.edit = true;
            });


        },
        getUserData() {

            this.getUserInfo.name === "undefined" ? this.payload.name = '' : this.payload.name = this.getUserInfo.name
            this.getUserInfo.lastName === "undefined" ? this.payload.last_name = '' : this.payload.last_name = this.getUserInfo.lastName
            this.getUserInfo.middleName === "undefined" ? this.payload.middle_name = '' : this.payload.middle_name = this.getUserInfo.middleName
            this.getUserInfo.email === "undefined" ? this.payload.email = '' : this.payload.email = this.getUserInfo.email
            this.getUserInfo.phone === "undefined" ? this.payload.phone = '' : this.payload.phone = this.getUserInfo.phone

            this.payload.delivery_address.city = this.getUserInfo.deliveryAddress.city
            this.payload.delivery_address.street = this.getUserInfo.deliveryAddress.street
            this.payload.delivery_address.flat = this.getUserInfo.deliveryAddress.flat
            this.getUserInfo.avatar === '' ? this.payload.avatar = '' : this.payload.avatar = this.getUserInfo.avatar

        }

    }
    ,
    computed: {
        ...
            mapGetters({
                getUserInfo: 'userData/userInfo',
                updatedInfo: 'userData/updatedData',
                getDataRestorePassword: 'auth/restorePasswordData'
            }),
        successChangePassword() {
            return this.getDataRestorePassword.message
        }
    }
    ,


}

